import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOOwnProductionApi } from '@/api/pto/project/estimate'
import { priceFormat } from '@/utils/form/priceFormat'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOOwnProductionApi,
  namePageDetailed: 'PtoProjectOwnProductionUpdate',
  expand: 'type,product_type',
  tableHeaders: [
    {
      title: 'Вид производства',
      isSortable: true,
      sortName: 'type.name'
    },
    {
      title: 'Вид продукции',
      isSortable: true,
      sortName: 'product_type.name'
    },
    {
      title: 'Объем',
      isSortable: true,
      sortName: 'volume'
    },
    {
      title: 'Цена',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Стоимость',
      isSortable: true,
      sortName: 'summary'
    },
    {
      title: 'Примечание',
      isSortable: true,
      sortName: 'note'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.type?.name || '-',
          item.product_type?.name || '-',
          item.volume || '-',
          priceFormat(item.price) || '-',
          priceFormat(item.summary) || '-',
          item.note || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
